import { Loader } from '@googlemaps/js-api-loader';

let googleMapsPromise: Promise<typeof google> | undefined;

export function loadGoogleMaps(apiKey: string): Promise<typeof google> {
  googleMapsPromise ??= new Loader({
    apiKey,
    version: 'weekly',
    libraries: ['maps', 'places'],
    region: 'NZ'
  }).load();
  return googleMapsPromise;
}
